import React from 'react'
import { trans } from '../../../../_providers/Translation'
import { Checkbox, FormControlLabel } from '@mui/material'

function Filter(props) {

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('search', '')
        props.handleSearch('active', '')
        props.handleSearch('superpartner', '')
    }

    console.log(`props.filter.active: ${props.filter.active}`)
    return (
        <form className="filter-standard schedule-filter">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1" selected>
                        {trans('random.search')}
                    </option>
                    <option value="5">
                        {trans('random.active')}
                    </option>
                    <option value="6">
                        {trans('random.superPartners')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">
                <input
                    type="search"
                    name="search"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    value={props.filter.search}
                    placeholder={trans('labels.search')}
                />
            </div>


            <div className="col" data-id="5" style={{ justifyContent: 'center' }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            id="search-active"
                            type="checkbox"
                            name="active"
                            value={1}
                            onChange={(e) => props.handleSearch(e.target.name, Number(e.target.checked))}
                            size='small'
                            checked={Number(props.filter.active) === 1 ? true : false}
                        />
                    }
                    label={trans('labels.active')}
                    sx={{
                        paddingLeft: '12px',
                    }}
                />
            </div>

            <div className="col" data-id="6" style={{ justifyContent: 'center' }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            id="search-superpartner"
                            type="checkbox"
                            name="superpartner"
                            value={1}
                            onChange={(e) => props.handleSearch(e.target.name, Number(e.target.checked))}
                            size='small'
                            checked={Number(props.filter.superpartner) === 1 ? true : false}
                        />
                    }
                    label={trans('labels.superPartner')}
                    sx={{
                        paddingLeft: '12px',
                    }}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>
        </form>
    )
}

export default Filter